import { render } from "./BackgroundBeamsComponent.vue?vue&type=template&id=20179f8f&scoped=true"
import script from "./BackgroundBeamsComponent.vue?vue&type=script&lang=js"
export * from "./BackgroundBeamsComponent.vue?vue&type=script&lang=js"

import "./BackgroundBeamsComponent.vue?vue&type=style&index=0&id=20179f8f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20179f8f"]])

export default __exports__